import type { Subtitle } from '@/modules/video/api/subtitle'

export type SubtitlePreviewField =
  | 'original_text'
  | 'translated_text'
  | 'translated_text_multiline'

export function unwrapSubtitleList(raw: unknown): Subtitle[] {
  if (Array.isArray(raw)) return raw as Subtitle[]
  if (raw && typeof raw === 'object') {
    const obj = raw as Record<string, unknown>
    if (Array.isArray(obj.items)) return obj.items as Subtitle[]
    if ('data' in obj) return unwrapSubtitleList(obj.data)
  }
  return []
}

export function formatSrtTimestamp(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) {
    return '00:00:00,000'
  }
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = Math.floor(seconds % 60)
  const ms = Math.floor((seconds % 1) * 1000)
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')},${ms.toString().padStart(3, '0')}`
}

export function formatSubtitlesAsSrt(
  subtitles: Subtitle[],
  field: SubtitlePreviewField,
): string {
  const sorted = [...subtitles].sort((a, b) => {
    if (a.start_time !== b.start_time) return a.start_time - b.start_time
    return (a.order_index ?? 0) - (b.order_index ?? 0)
  })
  const cues: string[] = []
  let index = 1
  for (const subtitle of sorted) {
    const text = (subtitle[field] || '').trim()
    if (!text) continue
    cues.push(
      `${index}\n${formatSrtTimestamp(subtitle.start_time)} --> ${formatSrtTimestamp(subtitle.end_time)}\n${text}`,
    )
    index += 1
  }
  return cues.join('\n\n')
}

export function pickActiveSubtitleTab(
  hasOriginal: boolean,
  translatedLangs: string[],
): string {
  if (hasOriginal) return 'original'
  if (translatedLangs.length > 0) return `translated-${translatedLangs[0]}`
  return 'original'
}
